import Comp from './LoginPage'
export default Comp
